import { PACKAGING_UNIT_PROFILES } from "@shared/products/packaging-impact";
import type { DimensionPreset } from "./product-presets";

export const EMPTY_BULK_BAG_WEIGHT_LBS = 5.08;
export const EMPTY_BAGS_PER_BALE = 200;
export const EMPTY_BALE_WEIGHT_LBS = Math.round(
  EMPTY_BAGS_PER_BALE * EMPTY_BULK_BAG_WEIGHT_LBS +
    PACKAGING_UNIT_PROFILES["wood-pallets"].typicalEmptyWeightLbs,
);

export const BULK_BAG_PRESETS: Array<DimensionPreset> = [
  {
    id: "empty-baled",
    label: `Empty, baled (${EMPTY_BAGS_PER_BALE} bags on a 48×40 pallet)`,
    lengthIn: 48,
    widthIn: 40,
    heightIn: 48,
    weightLbs: EMPTY_BALE_WEIGHT_LBS,
    stackable: true,
    unitLabels: { singular: "Bale", plural: "Bales" },
  },
  {
    id: "filled-35x35x40",
    label: "Filled 35×35×40 (2,000 lb)",
    lengthIn: 35,
    widthIn: 35,
    heightIn: 40,
    weightLbs: 2_000,
    stackable: false,
  },
  {
    id: "filled-35x35x50",
    label: "Filled 35×35×50 (3,000 lb)",
    lengthIn: 35,
    widthIn: 35,
    heightIn: 50,
    weightLbs: 3_000,
    stackable: false,
  },
  { id: "custom", label: "Custom", lengthIn: 0, widthIn: 0, heightIn: 0 },
];
